import { render, staticRenderFns } from "./ElTag.vue?vue&type=template&id=21fdaf2a&functional=true&"
import script from "./ElTag.vue?vue&type=script&lang=js&"
export * from "./ElTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports